// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3wbvt","name":"Header_name__3yHdC","birthday":"Header_birthday__2GPGc","skeleton":"Header_skeleton__3DgOG"};